import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

function EditSubCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token"); // Correctly get token
  const baseUrl = process.env.REACT_APP_APIURL;

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [formdata, setFormdata] = useState({
    name: "",
    category: "",
  });

  useEffect(() => {
    if (!token) {
      toast.error("Authentication token not found.");
      return;
    }

    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${baseUrl}api/catagorylist`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCategories(response.data?.catagories || []);
      } catch (error) {
        toast.error("Failed to fetch categories.");
      }
    };

    const fetchSubCategoryDetails = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}api/sub-category/details/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const { name, category } = response.data?.data || {};
        setFormdata({
          name: name || "",
          category: category?._id || "", // Ensure we get the ID from the populated category object
        });
      } catch (error) {
        toast.error("Failed to fetch sub-category details.");
      }
    };

    fetchCategories();
    fetchSubCategoryDetails();
  }, [id, token, baseUrl]);

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formdata.name || !formdata.category) {
      toast.warn("Please fill out all fields.");
      return;
    }
    setLoading(true);

    try {
      await axios.put(
        `${baseUrl}api/sub-category/update/${id}`,
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Sub-category updated successfully!");
      navigate("/sub-category/list"); // Corrected navigation path
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update sub-category"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Edit Sub-Category</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/sub-category-list">Sub-Category List</Link>
              </li>
              <li className="breadcrumb-item active">Edit Sub-Category</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Edit Sub-Category</h5>
            <form className="row g-3 pt-3" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <div className="form-floating">
                  <select
                    className="form-select"
                    id="category"
                    name="category"
                    value={formdata.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Parent Category</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.catagoryname}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="category">Parent Category</label>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Sub-Category Name"
                    name="name"
                    value={formdata.name}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Sub-Category Name</label>
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Sub-Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default EditSubCategory;
